// import React from 'react';

// const Work = () => {
//   return (
//     <div className="work-3__area work-3__inner-wrapper work-3__plr work-3__space">
//       <div className="container-fluid">
//         <div className="row row-cols-xl-3 row-cols-md-2 justify-content-center">
//           <div
//             className="col col-6 col-12 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".5s"
//           >
//             <div className="work-3__wrapper inner-wrapper-1 mb-30">
//               <div className="work-3__item">
//                 <div className="work-3__content d-flex align-items-center mb-15">
//                   <div className="work-3__icon icon-color-1">
//                     <span>
//                       <i className="fas fa-lightbulb-on"></i>
//                     </span>
//                   </div>
//                   <div className="work-3__title">
//                     <h4 className="work-3__section-title">
//                       <a href="#">Social This Promotion</a>
//                     </h4>
//                   </div>
//                 </div>
//                 <div className="work-3__right-text">
//                   <p>
//                     Business building it before the tab providet best aency
//                     srvice management, Payroll.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div
//             className="col col-6 col-12 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".7s"
//           >
//             <div className="work-3__wrapper inner-wrapper-2 mb-30">
//               <div className="work-3__item">
//                 <div className="work-3__content d-flex align-items-center mb-15">
//                   <div className="work-3__icon icon-color-1">
//                     <span>
//                       <i className="fas fa-cogs"></i>
//                     </span>
//                   </div>
//                   <div className="work-3__title">
//                     <h4 className="work-3__section-title">
//                       <a href="#"> Apply This Principles </a>
//                     </h4>
//                   </div>
//                 </div>
//                 <div className="work-3__right-text">
//                   <p>
//                     Business building it before the tab providet best aency
//                     srvice management, Payroll.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div
//             className="col col-6 col-12 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".9s"
//           >
//             <div className="work-3__wrapper inner-wrapper-3 mb-30">
//               <div className="work-3__item">
//                 <div className="work-3__content d-flex align-items-center mb-15">
//                   <div className="work-3__icon icon-color-1">
//                     <span>
//                       <i className="fas fa-chart-bar"></i>
//                     </span>
//                   </div>
//                   <div className="work-3__title">
//                     <h4 className="work-3__section-title">
//                       <a href="#">Embedded Off Systems</a>
//                     </h4>
//                   </div>
//                 </div>
//                 <div className="work-3__right-text">
//                   <p>
//                     Business building it before the tab providet best aency
//                     srvice management, Payroll.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div
//             className="col col-6 col-12 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay="1.0s"
//           >
//             <div className="work-3__wrapper inner-wrapper-4 mb-30">
//               <div className="work-3__item">
//                 <div className="work-3__content d-flex align-items-center mb-15">
//                   <div className="work-3__icon icon-color-1">
//                     <span>
//                       <i className="fas fa-lightbulb-on"></i>
//                     </span>
//                   </div>
//                   <div className="work-3__title">
//                     <h4 className="work-3__section-title">
//                       <a href="#">Business of Promotion</a>
//                     </h4>
//                   </div>
//                 </div>
//                 <div className="work-3__right-text">
//                   <p>
//                     Business building it before the tab providet best aency
//                     srvice management, Payroll.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div
//             className="col col-6 col-12 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay="1.1s"
//           >
//             <div className="work-3__wrapper inner-wrapper-5 mb-30">
//               <div className="work-3__item">
//                 <div className="work-3__content d-flex align-items-center mb-15">
//                   <div className="work-3__icon icon-color-1">
//                     <span>
//                       <i className="fas fa-lightbulb-on"></i>
//                     </span>
//                   </div>
//                   <div className="work-3__title">
//                     <h4 className="work-3__section-title">
//                       <a href="#">This Promotion Agncy</a>
//                     </h4>
//                   </div>
//                 </div>
//                 <div className="work-3__right-text">
//                   <p>
//                     Business building it before the tab providet best aency
//                     srvice management, Payroll.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Work;
import React from 'react';

const Work = () => {
  return (
    <div className="work-3__area work-3__inner-wrapper work-3__plr work-3__space">
      <div className="container-fluid">
        <div className="row row-cols-xl-3 row-cols-md-2 justify-content-center">
          {/* Item 1: Innovative Digital Strategy */}
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="work-3__wrapper inner-wrapper-1 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-lightbulb-on"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      <a href="#">Innovative Digital Strategy</a>
                    </h4>
                  </div>
                </div>
                <div className="work-3__right-text">
                  <p>
                    We craft tailored digital strategies that drive business growth and transformation. Our expert team leverages market insights and innovative tools to ensure your technology roadmap is future-ready.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Item 2: Agile Development Process */}
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="work-3__wrapper inner-wrapper-2 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-2">
                    <span>
                      <i className="fas fa-cogs"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      <a href="#">Agile Development Process</a>
                    </h4>
                  </div>
                </div>
                <div className="work-3__right-text">
                  <p>
                    Utilizing agile methodologies, we deliver scalable and efficient software solutions. Our iterative approach ensures flexibility, rapid development, and high-quality results.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Item 3: Scalable System Integration */}
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <div className="work-3__wrapper inner-wrapper-3 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-3">
                    <span>
                      <i className="fas fa-sitemap"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      <a href="#">Scalable System Integration</a>
                    </h4>
                  </div>
                </div>
                <div className="work-3__right-text">
                  <p>
                    Our solutions seamlessly integrate with your existing infrastructure, ensuring smooth data flow and improved operational efficiency across all platforms.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Item 4: Customer-Centric Solutions */}
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.0s"
          >
            <div className="work-3__wrapper inner-wrapper-4 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-4">
                    <span>
                      <i className="fas fa-user-friends"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      <a href="#">Customer-Centric Solutions</a>
                    </h4>
                  </div>
                </div>
                <div className="work-3__right-text">
                  <p>
                    We design solutions with your customers in mind, ensuring that every system enhances engagement and satisfaction. Our approach is focused on delivering measurable impact and lasting value.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Item 5: Reliable Support & Maintenance */}
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.1s"
          >
            <div className="work-3__wrapper inner-wrapper-5 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-5">
                    <span>
                      <i className="fas fa-headset"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      <a href="#">Reliable Support &amp; Maintenance</a>
                    </h4>
                  </div>
                </div>
                <div className="work-3__right-text">
                  <p>
                    Beyond development, we offer ongoing support and maintenance to ensure your systems operate seamlessly. Our dedicated team is always available to address any challenges and keep your business running smoothly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
